import fitvids from "fitvids";
import LazyLoad from "vanilla-lazyload";

const Common = {
  init() {
    new LazyLoad();

    Common.events();
  },

  events() {
    $(".scroll-to").on("click", (e) => {
      const btnEl = $(e.currentTarget);
      const target = btnEl.data("target");

      let offset;

      if ("top" == target) {
        offset = 0;
      } else {
        offset = $(target).offset().top - 200;
      }
      $("html,body").animate({
        scrollTop: offset,
      });
    });

    // Table
    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );
    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });

    // Fitvids
    fitvids();

    // Video.
    $(".flex-video__overlay").on("click", function () {
      $(this).parent().addClass("playing").find("video")[0].play();
    });

    // Accordion
    $(".accordion").on("click", function () {
      $(this).toggleClass("active").next().slideToggle();
    });

    // SEO
    $(".seo__more-btn").on("click", function () {
      let content = document.getElementsByClassName("seo__content-2")[0];
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }

      let text = $(this).children()[0].innerText;

      if (text == "LASĪT VAIRĀK") {
        $(this).children("span").text("Lasīt mazāk");
      } else {
        $(this).children("span").text("Lasīt vairāk");
      }

      $(this).toggleClass("active");
    });

    // FAQ
    $(".faq__more-btn").on("click", function () {
      $(this).siblings("ol").children("li:gt(2)").slideToggle();
      let text = $(this).children()[0].innerText;

      if (text == "LASĪT VAIRĀK") {
        $(this).children("span").text("Lasīt mazāk");
      } else {
        $(this).children("span").text("Lasīt vairāk");
      }
      $(this).toggleClass("active");
    });
  },
};

export default Common;
